export interface InteractionConfig {
	img: string;
	from: string;
	volume?: number;
	timeout?: number; // time after which the interaction gets hidden - in ms

	BuyerInfo?: {
		'has-plus': boolean;
		name: string;
	};
}

export function validateConfig(c: InteractionConfig): boolean {
	if (!c) {
		return false;
	}
	if (!c.img) {
		return false;
	}
	if (!c.timeout) {
		const queryParams = new URLSearchParams(window.location.search);
		c.timeout = Number(queryParams.get('timeout') || queryParams.get('pauseOnEndMS') || '20000');
	}
	return true;
}
